module.exports = __webpack_public_path__ + "img/lbl-02.9843b908.png";